import React from 'react';
import {setSubentries, setPolies} from './../../LexemePage';
import {LexemeUtilities} from './../LexemeHelper';
import Dict from 'dict-lib';
import {userService} from "../../../../_redux/authentication/services/user.services";
import {AdministrationUtilities} from "../../../../administration/AdministrationHelper";


const updateSubs = ['SET_SUBENTRIES'];
var updateClasses = ['subentries'];

export const deleteSubentry = (ids, isPoly) => {
    LexemeUtilities.callResetTabPages('/subentries/deleteSubentry/' + ids + '/' + updateSubs, [isPoly ? 'modal-body' : 'lexemeSubentries monoSubentries']);
};

export const saveSubentry = (item) => {
    item = escape(encodeURIComponent(item));
    return LexemeUtilities.call('/subentries/saveSubentry/' + item + '/' + updateSubs);
};

export const addNewSense = (rootId, item, langList, text, isTree, langDescr, pageStatus, host) => {

    var ids = "";

    if (JSON.parse(isTree)) {
        langList.map((item) => {
            ids += item.id_lang + "_";
        });

        ids = ids.substring(0, ids.length - 1);
    } else
        ids = langList;

    const defaultTopic = userService.getDefaultTopic();
    text = LexemeUtilities.encodeUrl(text);

    const foundExternalCreateEnvironment = LexemeUtilities.foundExternalCreateEnvironment();
    const externalHost = host;//AdministrationUtilities.getAlignmentDictionaryHost();
    const treeTitle = AdministrationUtilities.getTreeTitle();
    const foundExternalHost = typeof externalHost !== 'undefined' && externalHost !== null && externalHost !== '';

    const path = '/subentries/addNewSense/' + item.ids + '/' + ids + '/' + text + '/' + langDescr + '/' + defaultTopic + '/' + (foundExternalHost ? treeTitle : 'null') + '/' + updateSubs;

    if (typeof pageStatus !== 'undefined' && pageStatus === 'READ_ONLY_EXTERNAL_CREATE') {
        return LexemeUtilities.callSimple(path, 'SPINNER_MSG_SENSE_CREATING', externalHost).then((result) => {
            LexemeUtilities.resetExternal(rootId, result, externalHost);
        });
    } else if (typeof pageStatus !== 'undefined' && pageStatus === 'TRANSLATION_SELECTOR') {
        return LexemeUtilities.callSimple(path, 'SPINNER_MSG_SENSE_CREATING', foundExternalCreateEnvironment ? externalHost : undefined)
    } else {
        return LexemeUtilities.callHighlight(path, 'su-ids-', true)
    }
};

export var setSubentriesOrder = (ids, isPoly, polies) => {
    return LexemeUtilities.callNoClose('/subentries/setSubentriesOrder/' + ids + '/' + ['SET_SUBENTRIES', 'SET_SENSES']);
};